import React from 'react';
import { Redirect } from 'react-router-dom';

import EditContact from 'App/Admin/Users/Contacts/EditContact';
import ImportContacts from 'App/shared/ImportContacts';
import ViewContacts from 'App/Admin/Users/Contacts/ViewContacts';
import ContactPropertyFinances from 'App/shared/ContactPropertyFinances';
import paths from 'config/local/paths';
import Page from 'shared/Page';
import Switch from 'shared/Switch';
import { translate } from 'App/Internationalization';
import {
	withAdministratorService,
	withContactService,
} from 'service-container';
import CreateContact from './CreateContact';

const InjectedViewContacts = withContactService(ViewContacts);
const InjectedEditContact = withAdministratorService(
	withContactService(EditContact)
);
const InjectedCreateContact = withAdministratorService(
	// @ts-ignore -- Existing HOC typing expects a userService shape that this route does not use.
	withContactService(CreateContact)
);
const ManagerContactPropertyFinances = (props) => (
	// eslint-disable-next-line react/jsx-props-no-spreading -- necessary for route wrapper
	<ContactPropertyFinances {...props} accessRole="manager" />
);

export default class Contacts extends React.Component {
	render() {
		return (
			<Switch>
				<Redirect
					exact
					from={paths.app.admin.contacts.root}
					to={paths.app.admin.contacts.view}
				/>
				<Page
					component={InjectedViewContacts}
					path={paths.app.admin.contacts.view}
					title={translate('admin.nav.contacts.view')}
				/>
				<Page
					component={ImportContacts}
					path={paths.app.admin.contacts.import}
					title={translate('admin.nav.contacts.import')}
				/>
				<Page
					component={ManagerContactPropertyFinances}
					exact
					path={paths.app.admin.contacts.propertyFinances}
					title={translate(
						'agent.pages.contacts.edit.finances_valuation.title'
					)}
				/>
				<Page
					component={InjectedEditContact}
					path={`${paths.app.admin.contacts.edit}/:contactId`}
					title={translate('admin.nav.contacts.edit')}
				/>
				<Page
					component={InjectedCreateContact}
					path={paths.app.admin.contacts.add}
					title={translate('admin.nav.contacts.add')}
				/>
			</Switch>
		);
	}
}
